import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Container, Typography, useTheme } from '@mui/material';
import List from './list/List';

const Propositions = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <Box
            component="section"
            sx={{
                py: { xs: 8, sm: 12, md: 16 },
                backgroundColor: theme.palette.background.default,
            }}
        >
            <Container maxWidth="lg">
                {/* Section Header */}
                <Box sx={{ textAlign: 'center', mb: { xs: 6, md: 8 } }}>
                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 600,
                            color: theme.palette.text.primary,
                            fontSize: {
                                xs: '2.25rem',
                                sm: '2.75rem',
                                md: '3.25rem',
                            },
                            lineHeight: 1.1,
                            letterSpacing: '-0.02em',
                            mb: 2,
                        }}
                    >
                        {t('valuePropositionSection.title')}
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{
                            color: theme.palette.text.secondary,
                            fontSize: '1.25rem',
                            maxWidth: '600px',
                            mx: 'auto',
                        }}
                    >
                        {t('valuePropositionSection.text')}
                    </Typography>
                </Box>

                <List />
            </Container>
        </Box>
    );
};

export default Propositions;